(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'bannerDegree', {
            bindings: {
                qual:       '<'
            },
            templateUrl:    'app/views/partials/layout/banner-degree.html',
            controller:     BannerDegreeController,
            controllerAs:   'vm'
        });


    /**
     * Renders the top page degree-specific banner and all its components.
     *
     * @param {ng.IScope} $scope
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {Utils} Utils
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     */
    function BannerDegreeController(
        $scope,
        ContentSwitchingService,
        Utils,
        TEXTS,
        CONFIG
    ){

        /** @type {angular.IController} */
        var vm = this;


        


        /* ===== EXPOSE TO THE SCOPE ======================================== */


        $scope._        = TEXTS.GENERIC.BANNER;
        $scope.utilService   = Utils;
        vm.banner = {};


        /* ===== EXPOSE TO THE CONTROLLER =================================== */

        vm.setModel = function( model ) {
            vm.selectablesModel = model;
        }

        vm.setKeyDatesCount = function( datesModel ) {
            vm.keyDatesCount = datesModel ? datesModel.length : null;
        };

        /** @constructor */
        vm.$onInit = function() {
            vm.isInternational = ContentSwitchingService.isInternational();
            setWatchers();
        };


        /** Private functions. */
        function setWatchers() {
            $scope.$watch("vm.qual", 
            /** @param {Object} qual */
            function(qual) {
                if(!qual) return;

                if(qual.type == CONFIG.ROUTES.GRADUATE_QUALS && !qual.actionPrimary) {
                    angular.extend(vm.banner, { CTAButton: buildBannerBtnObject(vm.isInternational) });
                }
            });
        }
        
        function buildBannerBtnObject(isInternational) {
            var CTAButton = Utils.getSharedContent().applyNowButtons.asset_contents;
            
            if(isInternational) {
                return CTAButton.international;
            } else {
                return CTAButton;
            }
        }

    }



    BannerDegreeController.$inject = [ '$scope', 'ContentSwitchingService', 'Utils', 'TEXTS', 'CONFIG' ];
})();
